// @credit: 76a97b1cd4349534e19fb23cf80c4a0f1b1502418015de1e9d68b95c44bc36d433ed49b8
//
// Aphilaty PWA — CloseMatchPrompt (AD-10)
//
// Shown when checkOrgNameMatch returns matchType==='close'. Presents up to
// 3 candidate orgs — user picks one (routes Path B) or selects "none of these"
// (routes Path A as a new-org request).

interface Candidate {
  orgId:   string;
  orgName: string;
}

interface Props {
  candidates: Candidate[];
  onSelect:    (orgId: string, orgName: string) => void;
  onNoneMatch: () => void;
}

export function CloseMatchPrompt({ candidates, onSelect, onNoneMatch }: Props) {
  return (
    <div style={{
      background: 'var(--color-bg-secondary)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      padding: '12px 14px',
      marginBottom: 12,
    }}>
      <p style={{ fontSize: 13, fontWeight: 500, color: 'var(--color-text)', marginBottom: 10 }}>
        Did you mean one of these existing organizations?
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {candidates.map(c => (
          <button
            key={c.orgId}
            type="button"
            className="btn btn-outline"
            style={{ textAlign: 'left', justifyContent: 'flex-start', fontSize: 13 }}
            onClick={() => onSelect(c.orgId, c.orgName)}
          >
            {c.orgName}
          </button>
        ))}
        <button
          type="button"
          className="btn btn-outline"
          style={{ textAlign: 'left', justifyContent: 'flex-start', fontSize: 12,
            color: 'var(--color-text-secondary)' }}
          onClick={onNoneMatch}
        >
          None of these — this is a new organization
        </button>
      </div>
    </div>
  );
}
